import { FaPlus } from "react-icons/fa";
import CardHeader from "../../atoms/CardHeader";
import IconButton from "../../atoms/IconButton";
import { useParams } from "react-router-dom";
import Card from "../../atoms/Card";
import UserRentaTable from "../../organisms/inmueble/inmuebleDocsTables/rentaUser/UserRentaTable";
import { useCallback, useEffect, useState } from "react";
import { GET_RENTA_ARCHIVOS } from "../../../api/apiFiles";
import SubHeading from "../../atoms/SubHeading";
import Breadcrumb from "../../molecules/Breadcrumb";
import { GET_INMUEBLE_ID } from "../../../api/apiInmuebles";

const InmuebleRentaTemplate = () => {
    const { idUser, im } = useParams();
    const [renta, setRenta] = useState();
    const [datosFacturacion, setDatosFacturacion] = useState();
    const [inmueble, setInmueble] = useState();

    const getInmueble = useCallback ( async () => {
        if (!im) return;
        try {
                const inmuebleData = await GET_INMUEBLE_ID(Number(im));
                setInmueble(inmuebleData);
            } catch (error) {
                console.error(error);
            }
        }, [im]);

    useEffect(() => {
        const getRenta = async () => {
            try {
                const rentasData = await GET_RENTA_ARCHIVOS(Number(im));
                const activeRenta = rentasData?.find(r => r.isActive);
                setRenta(activeRenta);

                let df = activeRenta?.datos_facturacion;

                if (typeof df === "string") {
                    try {
                        df = JSON.parse(df);
                    } catch (error) {
                        console.error("Error al parsear datos_facturacion:", error);
                        df = {};
                    }
                }

                setDatosFacturacion(df || {});
            } catch (error) {
                console.error(error);
            }
        }

        getRenta();
    });

        useEffect(() => {
        if (!im) return;
        getInmueble();
    },[getInmueble, im]);

    return (
        <div className="flex flex-col gap-4">
            <CardHeader
                          left={
                            <Breadcrumb
                              items={[
                                { label: inmueble?.name, to: `/${idUser}/${im}` },
                                { label: "Archivos de la renta", to: null },
                              ]}
                            />
                          }
                right={<IconButton icon={FaPlus} bgColor="bg-white" disabled/>}
            />
            <Card>
            {datosFacturacion && (
                <>
                    <SubHeading text="Datos de facturación" color="blue" />
                    <div className="w-full grid grid-cols-2">
                        <p><strong>Razón Social:</strong> {datosFacturacion.razonSocial || "N/A"}</p>
                        <p><strong>RFC:</strong> {datosFacturacion.rfc || "N/A"}</p>
                        <p><strong>Uso CFDI:</strong> {datosFacturacion.usoCFDI || "N/A"}</p>
                        <p><strong>Email:</strong> {datosFacturacion.email || "N/A"}</p>
                    </div>
                </>
            )}
                <UserRentaTable data={renta}/>
            </Card>
        </div>
    );
};

export default InmuebleRentaTemplate;